<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="copyright"></a><a id="page_iv"></a>Copyright © 2010 by P. J. O’Rourke</p>
<p class="copyright">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003 or permissions@groveatlantic.com.</p>
<p class="copyright"><em>Published simultaneously in Canada</em></p>
<p class="copyright"><em>Printed in the United States of America</em></p>
<p class="copyright">E-book ISBN: 978-0-8021-9626-2</p>
<p class="copyright">Atlantic Monthly Press<br/>an imprint of Grove/Atlantic, Inc.<br/>841 Broadway<br/>New York, NY 10003</p>
<p class="copyright">Distributed by Publishers Group West<br/><span class="weblink"><a class="nounder" href="http://www.groveatlantic.com" target="_blank">www.groveatlantic.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?59679490